<hpm-header [title]="'TEMPLATE_OVERVIEW.TITLE'" [showNotifications]="true"></hpm-header>
<div class="container">
  <hpm-tab-navigation></hpm-tab-navigation>
  <hpm-template-table></hpm-template-table>
</div>
